module.exports = __webpack_public_path__ + "static/homem-notebook-camisa-azul-f26ccfc8bb2466b66f3b96331dcf7888.png";